import Layout from "../../Layout"

const Notification = () => {
  return (
    <Layout>
      <div></div>
    </Layout>
  )
}

export default Notification
